import React, {useEffect, useLayoutEffect, useState} from "react";
import { useKeenSlider } from "keen-slider/react"
import "keen-slider/keen-slider.min.css"
import ReactPlayer from 'react-player'
import {useModal} from "../context";

export default function Home(){
    const {show, hide} = useModal();
    const [switchOn, setSwitchOn] = useState(false);
    const [tab, setTab] = useState(1);
    const [loaded, setLoaded] = useState(false);
    const [currentProdSlide, setCurrentProdSlide] = useState(0);
    const [sliderRef, instanceRef] = useKeenSlider({
        slides: 1,
        initial: 0,
        loop: true,
        defaultAnimation: {
          duration: 1000
        },
        created() {
            setLoaded(true)
        },
    });

    const [loaded2, setLoaded2] = useState(false);
    const [sliderRef2, instanceRef2] = useKeenSlider({
        slides: {
            perView: 3,
            spacing: 0,
        },
        breakpoints: {
            '(max-width: 1023px)': {
                slides: {
                    perView: 1,
                    spacing: 0,
                },
            },
        },
        loop: true,
        defaultAnimation: {
            duration: 1000
        },
        slideChanged(slider) {
            setCurrentProdSlide(slider.track.details.rel)
        },
        created() {
            setLoaded2(true)
        },
    });

    return(
        <div className={'content' + (switchOn ? ' content--theme-orange' : '')}>
            <div className="sc__promo">
                <div ref={sliderRef} className="fader">
                    <div className="fader__slide">
                        <div className="promo__it promo__it--3">
                            <div className="promo__it-img">
                                <div className="promo__it-img-wrap">
                                    <img src={require("../assets/img/promo.jpg")} className="desk-only"/>
                                    <img src={require("../assets/img/promo-mb.jpg")} className="mb-only"/>
                                </div>

                                <div className="promo__it-ct-bg">
                                    <svg className="desk-only" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="2 0 104 618" width="106.4" height="618"><path fill="white" d="M0-5v675h22.4c-7-28.2-12-59-17-91-6-38.3-4-90.3 2-126 16.6-99.7 37-180.4 63-269 16.4-55.5 36-122.3 36-189H0z"/></svg>
                                    <svg className="mb-only" preserveAspectRatio="none" viewBox="0 0 374 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M-1.83555 0.347748L-1.875 11.0001H376.875L376.855 0.347748C376.855 0.347748 305.268 10.7831 187.283 10.8817C69.2984 10.9804 -1.83555 0.347748 -1.83555 0.347748Z" fill="white"/>
                                    </svg>

                                </div>
                            </div>
                            <div className="promo__it-ct d-flex align-items-center">
                                <div className="promo__it-ct-bl">
                                    <h1 className="promo__it-title promo__it-title--over">
                                        Kinder Pingui <br/>
                                        Мандарин
                                    </h1>
                                    <div className="promo__it-descr">
                                        <p>
                                            Kinder Pingui Мандарин&nbsp;&mdash; это нежный бисквит с&nbsp;хрустящим шоколадом и&nbsp;молочно-мандариновой начинкой. Вкусный и&nbsp;яркий Киндер Пингви Мандарин прекрасно подойдет для зимнего легкого перекуса.
                                        </p>
                                        <p>
                                            Как и&nbsp;все молочные продукты, хранить Kinder Pingui Мандарин нужно только в&nbsp;холодильнике.
                                        </p>
                                        <p>
                                            Порадуйте себя и&nbsp;своих детей вкусным перерывом с&nbsp;Kinder Pingui Мандарин.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="promo__it-ct-bg2 desk-only">
                                <svg viewBox="0 0 1920 54" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                    <path fill="#ffffff" d="M0.2,0 L0,54 L1920,54 L1919.9,0 C1919.9,0 1557,52.9 958.9,53.4 C360.8,53.9 0.2,0 0.2,0 Z"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="sc__product-about">
                {switchOn && (
                    <>
                        <div className="products__decor products__decor--1"/>
                        <div className="products__decor products__decor--2"/>
                        <div className="products__decor products__decor--3"/>
                        <div className="products__decor products__decor--4"/>
                        <div className="products__decor products__decor--5"/>
                        <div className="products__decor products__decor--6"/>
                        <div className="products__decor products__decor--7"/>
                        <div className="products__decor products__decor--8"/>
                        <div className="products__decor products__decor--9"/>
                        <div className="products__decor products__decor--10"/>
                    </>
                )}
                <div onClick={()=>{
                    setSwitchOn(!switchOn);
                }} className="products__toggle-box">
                    <div className={'products__toggle' + (switchOn ? ' active' : '')}>

                    </div>
                    <div className="products__toggle-title d-flex align-items-center justify-content-center">
                        <div>
                            Нажимайте и включайте <br/>
                            мандариновое настроение!
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="product__box">
                        <div className="product__box-video d-flex align-items-center justify-content-center">
                            <ReactPlayer
                                url={(window.matchMedia("(min-width: 1024px)").matches ? '/videos/desktop.mp4' : '/videos/mobile.mp4')}
                                controls={true}
                                muted={true}
                                playing={true}
                                playsinline={true}
                                loop={true}
                            />
                        </div>
                    </div>
                    <div className="product__box">
                        <div className="tabs__box">
                            <div className="tabs__list d-flex justify-content-center align-items-center">
                                <div onClick={()=>{
                                    setTab(1);
                                }} className={'tabs__btn d-flex align-items-center justify-content-center' + (tab === 1 ? ' active' : '')}>
                                    <div className="tabs__btn-link">
                                        Состав
                                    </div>
                                </div>
                                <div onClick={()=>{
                                    setTab(2);
                                }} className={'tabs__btn d-flex align-items-center justify-content-center' + (tab === 2 ? ' active' : '')}>
                                    <div className="tabs__btn-link">
                                        Пищевая ценность
                                    </div>
                                </div>
                            </div>
                            <div className="tabs__content">
                                {tab === 1 && (
                                    <div className="tabs__content-it fadeIn animated">
                                        <div className="text__title text-center">
                                            Состав
                                        </div>
                                        <div className="text__descr text-center">
                                            Начинка из&nbsp;мандарина (сок мандарина, сахар, сироп глюкозы, стабилизатор: пектин; регуляторы кислотности: лимонная кислота, цитрат натрия; ароматизатор), шоколад 19,5% (сахар, тёртое какао, масло какао, эмульгатор: лецитины (соевый); ванилин, пастеризованное молоко, сахар, пальмовое масло, пшеничная мука, сухое обезжиренное молоко, обезвоженный молочный жир, декстроза, яичный порошок, какао с&nbsp;пониженным содержанием жира, дрожжи, ароматизаторы, эмульгатор: моно- и&nbsp;диглицериды жирных кислот; соль, сухой экстракт ячменного солода. Содержит молоко, яйца, злаки, содержащие глютен, сою и&nbsp;продукты их&nbsp;переработки.
                                        </div>
                                    </div>
                                )}

                                {tab === 2 && (
                                    <div className="tabs__content-it fadeIn animated">
                                        <div className="tabs__content-bl">
                                            <div className="text__tb">
                                                <table>
                                                    <tr>
                                                        <td>
                                                            Пищевая <br/>
                                                            ценность продукта
                                                        </td>
                                                        <td>
                                                            100 г
                                                        </td>
                                                        <td>
                                                            30 г
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            Энергетическая <br/>
                                                            ценность продукта <br/>
                                                            ккал/кдж
                                                        </td>
                                                        <td>
                                                            1965/469
                                                        </td>
                                                        <td>
                                                            588/141
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            Белки
                                                        </td>
                                                        <td>
                                                            5,5
                                                        </td>
                                                        <td>
                                                            1,7
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            Углеводы
                                                        </td>
                                                        <td>
                                                            40,4
                                                        </td>
                                                        <td>
                                                            12,1
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            Жиры
                                                        </td>
                                                        <td>
                                                            31,1
                                                        </td>
                                                        <td>
                                                            9,3
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="product__box-after">
                            <div className="tabs__content-bl">
                                <div className="text__important text-center">
                                    Не&nbsp;содержит красителей и&nbsp;консервантов.
                                </div>
                            </div>
                            {/*<div className="tabs__content-bl">
                                <div className="text__subtitle text-center">
                                    Узнать больше о&nbsp;наших ингредиентах
                                </div>
                                <div className="d-flex justify-content-center">
                                    <a href="#" target="_blank" className="btn__promo d-flex align-items-center justify-content-center">
                                        Подробнее
                                    </a>
                                </div>
                            </div>*/}
                        </div>
                    </div>
                </div>
            </div>
            <div className="sc__products">
                <div className="products__bg-top">
                    <svg className="desk-only" viewBox="0 0 1442 92" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                        <path d="M0.500977 0.280762V67.6742C5.50792 65.1708 124.173 6.38923 355.994 0.280762H0.500977ZM453.93 0.280762C726.308 4.98729 892.538 41.3377 1085.51 76.887C1288.49 114.439 1436.19 67.6742 1441.5 65.8717V0.380901L453.93 0.280762Z" fill="white"/>
                    </svg>
                    <svg className="mb-only" viewBox="0 0 375 27" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                        <path d="M0 0V19.8228C1.30299 19.0864 32.1838 1.79672 92.5122 0H0ZM117.999 0C188.881 1.38435 232.14 12.0763 282.358 22.5326C335.181 33.578 373.619 19.8228 375 19.2926V0.0294544L117.999 0Z" fill="white"/>
                    </svg>
                </div>
                <div className="products__bg-bottom">
                    <svg className="desk-only" width="1442" height="73" viewBox="0 0 1442 73" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                        <path d="M0.150208 31.5107L0 72.067H1442L1441.92 31.5107C1441.92 31.5107 1169.37 71.2408 720.174 71.6164C270.976 71.9919 0.150208 31.5107 0.150208 31.5107Z" fill="white"/>
                    </svg>
                    <svg className="mb-only" viewBox="0 0 375 11" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                        <path d="M-3.96034 0L-4 10.7086H376.75L376.73 0C376.73 0 304.764 10.4905 186.157 10.5896C67.5493 10.6888 -3.96034 0 -3.96034 0Z" fill="white"/>
                    </svg>
                </div>
                <div className="container">
                    <div className="prod__sl-box">
                        <div onClick={(e) =>
                            e.stopPropagation() || instanceRef2.current?.prev()
                        } className="carousel-button carousel-button-prev">
                            <svg className="desk-only" width="63" height="63" viewBox="0 0 63 63" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Previous">
                                <g filter="url(#filter0_d_17_12219)">
                                    <circle cx="28" cy="28" r="28" transform="rotate(180 28 28)" fill="#009FE5"></circle>
                                    <path fillRule="evenodd" clipRule="evenodd"
                                          d="M32.3107 18.4041C32.3107 18.4041 23.763 22.7548 20.7674 25.6091C17.7717 28.4634 20.7674 30.3632 20.7674 30.3632L31.7897 37.8665C31.7897 37.8665 33.5391 38.4842 33.5391 36.2461C33.5391 34.0081 33.5391 32.4014 33.5391 32.4014C33.5391 32.4014 33.4614 30.7687 26.4043 28.4634C26.4043 28.4634 25.1153 27.6339 33.2101 23.5921C33.2101 23.5921 34.1949 22.7938 33.9498 20.4994C33.7047 18.2049 32.3107 18.4041 32.3107 18.4041Z"
                                          fill="white"></path>
                                </g>
                                <defs>
                                    <filter id="filter0_d_17_12219" x="0" y="0" width="63" height="63"
                                            filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
                                        <feColorMatrix in="SourceAlpha" type="matrix"
                                                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                       result="hardAlpha"></feColorMatrix>
                                        <feOffset dx="7" dy="7"></feOffset>
                                        <feComposite in2="hardAlpha" operator="out"></feComposite>
                                        <feColorMatrix type="matrix"
                                                       values="0 0 0 0 0.929412 0 0 0 0 0.898039 0 0 0 0 0.85098 0 0 0 1 0"></feColorMatrix>
                                        <feBlend mode="normal" in2="BackgroundImageFix"
                                                 result="effect1_dropShadow_17_12219"></feBlend>
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_17_12219"
                                                 result="shape"></feBlend>
                                    </filter>
                                </defs>
                            </svg>
                        </div>
                        <div onClick={(e) =>
                            e.stopPropagation() || instanceRef2.current?.next()
                        } className="carousel-button carousel-button-next">
                            <svg className="desk-only" width="63" height="63" viewBox="0 0 63 63" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g filter="url(#filter0_d_259_35592)">
                                    <circle cx="28" cy="28" r="28" fill="#009FE5"></circle>
                                    <path fillRule="evenodd" clipRule="evenodd"
                                          d="M23.6893 37.5959C23.6893 37.5959 32.237 33.2452 35.2326 30.3909C38.2283 27.5366 35.2326 25.6368 35.2326 25.6368L24.2103 18.1335C24.2103 18.1335 22.4609 17.5158 22.4609 19.7539C22.4609 21.9919 22.4609 23.5986 22.4609 23.5986C22.4609 23.5986 22.5386 25.2313 29.5957 27.5366C29.5957 27.5366 30.8847 28.3661 22.7899 32.4079C22.7899 32.4079 21.8051 33.2062 22.0502 35.5006C22.2953 37.7951 23.6893 37.5959 23.6893 37.5959Z"
                                          fill="white"></path>
                                </g>
                                <defs>
                                    <filter id="filter0_d_259_35592" x="0" y="0" width="63" height="63"
                                            filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
                                        <feColorMatrix in="SourceAlpha" type="matrix"
                                                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                       result="hardAlpha"></feColorMatrix>
                                        <feOffset dx="7" dy="7"></feOffset>
                                        <feComposite in2="hardAlpha" operator="out"></feComposite>
                                        <feColorMatrix type="matrix"
                                                       values="0 0 0 0 0.929412 0 0 0 0 0.898039 0 0 0 0 0.85098 0 0 0 1 0"></feColorMatrix>
                                        <feBlend mode="normal" in2="BackgroundImageFix"
                                                 result="effect1_dropShadow_259_35592"></feBlend>
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_259_35592"
                                                 result="shape"></feBlend>
                                    </filter>
                                </defs>
                            </svg>
                        </div>
                        <div className="prod__sl">
                            <div ref={sliderRef2} className="keen-slider">
                                <div className="keen-slider__slide">
                                    <div className="prod__sl-it">
                                        <div className="prod__sl-it-img">
                                            <img src={require("../assets/img/prod-1.png")}/>
                                        </div>
                                        <div className="prod__sl-it-title">
                                            Kinder Pingui, 30г
                                        </div>
                                    </div>
                                </div>
                                <div className="keen-slider__slide">
                                    <div className="prod__sl-it">
                                        <div className="prod__sl-it-img">
                                            <img src={require("../assets/img/prod-2.png")}/>
                                        </div>
                                        <div className="prod__sl-it-title">
                                            Kinder Pingui 4шт x 30г
                                        </div>
                                    </div>
                                </div>
                                <div className="keen-slider__slide">
                                    <div className="prod__sl-it">
                                        <div className="prod__sl-it-img">
                                            <img src={require("../assets/img/prod-3.png")}/>
                                        </div>
                                        <div className="prod__sl-it-title">
                                            Kinder Pingui Кокос, 30г
                                        </div>
                                    </div>
                                </div>
                                <div className="keen-slider__slide">
                                    <div className="prod__sl-it">
                                        <div className="prod__sl-it-img">
                                            <img src={require("../assets/img/prod-4.png")}/>
                                        </div>
                                        <div className="prod__sl-it-title">
                                            Kinder Pingui Мандарин, 30г
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="prod__sl-dots d-flex align-items-center justify-content-center desk-only">
                            <button onClick={()=>{
                                instanceRef2.current?.moveToIdx(0)
                            }}  type="button" className={'prod__sl-dot' + (currentProdSlide === 0 || currentProdSlide === 3 ? ' active' : '')}/>
                            <button onClick={()=>{
                                instanceRef2.current?.moveToIdx(1)
                            }} type="button" className={'prod__sl-dot' + (currentProdSlide === 1 || currentProdSlide === 2 ? ' active' : '')}/>
                        </div>
                        <div className="prod__sl-dots d-flex align-items-center justify-content-center mb-only">
                            <button onClick={()=>{
                                instanceRef2.current?.moveToIdx(0)
                            }}  type="button" className={'prod__sl-dot' + (currentProdSlide === 0 ? ' active' : '')}/>
                            <button onClick={()=>{
                                instanceRef2.current?.moveToIdx(1)
                            }}  type="button" className={'prod__sl-dot' + (currentProdSlide === 1 ? ' active' : '')}/>
                            <button onClick={()=>{
                                instanceRef2.current?.moveToIdx(2)
                            }}  type="button" className={'prod__sl-dot' + (currentProdSlide === 2 ? ' active' : '')}/>
                            <button onClick={()=>{
                                instanceRef2.current?.moveToIdx(3)
                            }}  type="button" className={'prod__sl-dot' + (currentProdSlide === 3 ? ' active' : '')}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}